import styled from 'styled-components';

export const WidgetsPanelContainerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  margin: 4px 8px;
  justify-content: space-between;

  div[data-testid='loader'] {
    left: 50vw;
  }

  div[data-testid='retry-layer'] {
    top: -18px;
  }
`;

export const WidgetsPanelCardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  border-radius: 5px;
  gap: 5px;
`;

// export const DndWrapper = styled.div`
//   display: grid;
//   grid-auto-rows: max-content;
//   box-sizing: border-box;
//   min-width: 350px;
//   padding-bottom: 0;
//   margin: 10px;
//   border-radius: 5px;
//   transition: background-color 350ms ease;
//   grid-template-columns: repeat(1, 1fr);
//   width: fit-content;
//   grid-auto-flow: column;
// `;

export const StyledCloseBtn = styled.div`
  position: absolute;
  right: 5px;
  top: 2px;
  opacity: 0;

  &:hover {
    opacity: 1;
  }
`;

export const VerticalSeparator = styled.hr`
  border: none;
  border-left: 1px solid #cbced1;
  height: 60px;
  width: 1px;
  margin-left: 0;
`;

export const WidgetContentWrapper = styled.div<{
  highlight?: boolean;
}>`
  display: flex;
  flex-direction: row;
  position: relative;
  cursor: pointer;
  background-color: ${(props) => (props.highlight ? '#F2F8FF' : '#fff')};
  border: 1px solid ${(props) => (props.highlight ? '#256eff' : '#E5E5E5')};
  border-radius: 4px;

  &:hover {
    background-color: #f2f8ff;
  }
`;

export const SPIWidgetWrapper = styled(WidgetContentWrapper)`
  .echarts-for-react {
    canvas {
      top: 20px !important;
    }
  }
`;

export const ImpactedSessionsWidgetWrapper = styled(WidgetContentWrapper)`
  min-width: fit-content;

  .echarts-for-react {
    canvas {
      top: 4px !important;
    }
  }
`;

export const GoodSessionsWidgetWrapper = styled(WidgetContentWrapper)`
  cursor: unset;
  min-width: fit-content;

  &:hover {
    background-color: #fff;
  }

  .echarts-for-react {
    canvas {
      top: 4px !important;
    }
  }
`;

export const MetricsWidgetWrapper = styled(WidgetContentWrapper)`
  &:hover {
    background-color: #fff;
  }
`;

export const WidgetTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;
  min-width: fit-content;
  border-radius: 4px;
  padding: 3px;
`;

export const MetricsCardTextWrapper = styled(WidgetTextWrapper)<
  {
    highlight?: boolean;
  } & {
    isClickable?: boolean;
  }
>`
  padding: 0 5px;
  cursor: pointer;
  background-color: ${(props) => (props.highlight ? '#F2F8FF' : '#fff')};
  border: 1px solid ${(props) => (props.highlight ? '#256eff' : '#E5E5E5')};
  border-radius: 4px;

  &:hover {
    background-color: #f2f8ff;
  }
`;

export const WidgetTitle = styled.div`
  font-style: normal;
  font-weight: 400;
  margin-top: 5px;
  font-size: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #595959;
`;

export const WidgetNumberWrapper = styled.div`
  font-size: 24px;
  margin-top: -5px;
`;

export const WidgetSubscriptWrapper = styled.span`
  display: flex;
  flex-direction: column;
  font-size: 10px;
  font-weight: 500;
  padding: 5px 0 5px 5px;
  color: #595959;

  span {
    color: black;
    margin-bottom: -3px;
  }
`;

export const CheckboxWrapper = styled.div`
  width: 510px;
  display: flex;
  flex-wrap: wrap;
  padding: 0 2px 10px;
`;

export const StyledEditIcon = styled.span`
  cursor: pointer;

  svg {
    &:hover {
      color: #2969ff;
    }
  }
`;

export const SPIScoreWrapper = styled.div<{
  isSettingsPresent: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${(props) => (props.isSettingsPresent ? 'space-between' : 'flex-start')};
  margin-right: 5px;
`;
